export default function AnalystsMemo() {
  return <div>Analysts Memo</div>;
}
